import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-label-modal-title',
    imports: [CommonModule],
    template: `
    <div class="font-medium text-base">
      {{ label }}
      <ng-content></ng-content>
    </div>
  `
})
export class LabelModalTitleComponent {
  @Input() label!: string;
}
